import { FC, useContext } from 'react';

import { Box } from '@mui/material';
import { SxStyles } from 'types';
import { mergeSx, numberToPixelsString } from 'utils';

import { paddingInlineLarge, paddingInlineSmall, paddingInlineSmallBackground } from '../const';
import { WidgetContainerContext } from '../context/widgetContainerContext';
import { IWidgetContainerPaddingProps } from '../types';

const styles = (withBackground: boolean, disableRightPadding?: boolean, borderTop?: string): SxStyles => {
  const paddingProperty = disableRightPadding ? 'paddingLeft' : 'paddingInline';

  return (theme) => {
    const options = {
      [paddingProperty]: numberToPixelsString(paddingInlineLarge),

      [theme.breakpoints.down('commonSm')]: {
        [paddingProperty]: numberToPixelsString(withBackground ? paddingInlineSmallBackground : paddingInlineSmall),
      },
    };

    if (borderTop) {
      options.borderTop = borderTop;
    }

    return options;
  };
};

const WidgetContainerPadding: FC<IWidgetContainerPaddingProps> = ({ sx, disableRightPadding, borderTop, children }) => {
  const { withBackground } = useContext(WidgetContainerContext);

  return (
    <Box className="widget-container-padding" sx={mergeSx(styles(withBackground, disableRightPadding, borderTop), sx)}>
      {children}
    </Box>
  );
};

export default WidgetContainerPadding;
